import React from "react";
import { makeGet } from "@culturehq/client";

import { useQueryString } from "app/context";
import { useFetch } from "app/hooks";
import { Loader, PlainButton } from "@culturehq/components";
import { queryKey } from "components/filters/InterestFilter";


const TopInterests = () => {
  const { onToggleQueryStringValue } = useQueryString();

  const descSort = array => (
    array.sort((a, b) => (
      b.userCount - a.userCount
    ))
  );

  const { fetching, json: { interests } } = useFetch(
    () => Promise.all([
      makeGet("/interests", {
        by: "most"
      })
    ]).then((
      [interestsResponse]
    ) => {
      const interests = descSort(interestsResponse.interests);
      return {
        interests: interests.slice(0, 5)
      };
    }),
    []
  );

  const onInterestClicked = interest => {
    onToggleQueryStringValue(queryKey, interest.id);
  };

  if (fetching) {
    return <Loader />;
  }

  return (
    <span className="TopInterests__tags">
      {interests?.map((interest, index) => (
        <span key={interest.id}>
          <PlainButton onClick={() => onInterestClicked(interest)}>
            {interest.name}
          </PlainButton>
          {index !== interests.length - 1 && ", "}
        </span>
      ))}
    </span>
  );
};

export default TopInterests;
